import { memo, useEffect } from "react";
import { Box, Grid2 } from "@mui/material";
import AIServicesNavbar from "../components/AIServicesNavbar";
import { useVsmeReport } from "@services/hooks/useVsmeReport";
import { useNavigate } from "react-router-dom";
import { RouteTo } from "@routing/RouteMap";
import { useDispatch } from "react-redux";
import { handleErrorWithNotification } from "@/utils/errorHandling";
import JobSubmissionForm from "@services/components/JobSubmissionForm";
import { FETCH_COMPANY } from "@company/graphql/queries/fetchCompany";
import { useQuery } from "@apollo/client";
import { Query } from "@/app/graphql/codegen";

const VsmeServicePage = memo(() => {
    const { submitJob, loading, error } = useVsmeReport();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    // Fetch company ID
    const { data: companyData } = useQuery<Pick<Query, "company">>(FETCH_COMPANY);
    const companyId = companyData?.company?.id || "";

    useEffect(() => {
        if (error) {
            handleErrorWithNotification(error as Error, dispatch, "Fehler beim Einreichen", "Der VSME Report konnte nicht gestartet werden.");
        }
    }, [error, dispatch]);

    const handleSubmit = async () => {
        const job = await submitJob([]);
        if (job?.id) {
            navigate(`${RouteTo.AI_SERVICES}/vsme/status/${job.id}`);
        } else {
            navigate(`${RouteTo.AI_SERVICES}/vsme/status/current`);
        }
    };

    return (
        <Box sx={{ p: 3 }}>
            <Grid2 container spacing={3}>
                {/* Sidebar */}
                <Grid2 size={{ xs: 12, md: 3 }}>
                    <AIServicesNavbar />
                </Grid2>

                {/* Main content */}
                <Grid2 size={{ xs: 12, md: 9 }}>
                    <JobSubmissionForm
                        title="VSME-Report-Generation"
                        description="Lassen Sie automatisch einen kompakten VSME-Report erstellen, der die Ergebnisse Ihrer Wesentlichkeitsanalyse aufbereitet und als Grundlage für Ihren Nachhaltigkeitsbericht dient."
                        loading={loading}
                        submitLabel="Report erstellen"
                        onSubmit={handleSubmit}
                        companyId={companyId}
                    />
                </Grid2>
            </Grid2>
        </Box>
    );
});

export default VsmeServicePage; 